import script from "./TagRestore.vue?vue&type=script&setup=true&lang=js"
export * from "./TagRestore.vue?vue&type=script&setup=true&lang=js"

import "./TagRestore.vue?vue&type=style&index=0&id=11ebed9a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11ebed9a"]])

export default __exports__